import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
  DropdownMenuSeparator,
  DropdownMenuLabel,
} from "@/components/ui/dropdown-menu";
import { Input } from "@/components/ui/input";
import { CalculatorIcon, DownloadSimple, FilePdf, FileXls, FileCsv, FloppyDisk, ArrowsClockwise } from "@phosphor-icons/react";
import InstallButton from "@/components/InstallButton";

export default function TopBar({
  templateName,
  onTemplateNameChange,
  onSave,
  onExportCSV,
  onExportXLSX,
  onExportPDF,
  onRefreshFX,
  fxDate,
  fxLoading,
}) {
  return (
    <header
      className="w-full bg-white border-b border-neutral-300 px-4 md:px-6 py-3 flex items-center justify-between gap-4 sticky top-0 z-30"
      data-testid="top-bar"
    >
      <div className="flex items-center gap-3 min-w-0">
        <div className="w-9 h-9 bg-[#002FA7] text-white flex items-center justify-center flex-shrink-0">
          <CalculatorIcon size={20} weight="bold" />
        </div>
        <div className="flex flex-col min-w-0">
          <span className="text-[10px] font-semibold tracking-[0.18em] uppercase text-neutral-500">
            Import Export Price Calculator
          </span>
          <Input
            data-testid="template-name-input"
            value={templateName}
            onChange={(e) => onTemplateNameChange(e.target.value)}
            placeholder="Untitled template"
            className="h-7 px-1 -mx-1 border-none shadow-none rounded-none font-display font-bold text-lg tracking-tight bg-transparent focus-visible:ring-0 focus-visible:bg-neutral-50 focus-visible:border-b focus-visible:border-[#002FA7]"
          />
        </div>
      </div>

      <div className="flex items-center gap-2 md:gap-3 flex-shrink-0">
        <InstallButton />
        <button
          onClick={onRefreshFX}
          data-testid="refresh-fx-button"
          disabled={fxLoading}
          className="hidden md:flex items-center gap-2 text-xs font-mono text-neutral-600 hover:text-[#002FA7] transition-colors px-2 py-1 border border-transparent hover:border-neutral-300"
          title="Refresh live FX rates"
        >
          <ArrowsClockwise
            size={14}
            className={fxLoading ? "animate-spin" : ""}
          />
          <span>FX · {fxDate || "—"}</span>
        </button>

        <Button
          data-testid="save-template-button"
          onClick={onSave}
          className="rounded-none bg-[#002FA7] hover:bg-black text-white font-medium gap-2 h-9"
        >
          <FloppyDisk size={16} weight="bold" />
          <span className="hidden sm:inline">Save</span>
        </Button>

        <DropdownMenu>
          <DropdownMenuTrigger asChild>
            <Button
              data-testid="export-menu-button"
              variant="outline"
              className="rounded-none border-neutral-900 hover:bg-neutral-100 gap-2 h-9"
            >
              <DownloadSimple size={16} weight="bold" />
              <span className="hidden sm:inline">Export</span>
            </Button>
          </DropdownMenuTrigger>
          <DropdownMenuContent
            align="end"
            className="rounded-none border-neutral-300 min-w-[180px]"
          >
            <DropdownMenuLabel className="text-[10px] uppercase tracking-[0.12em] text-neutral-500">
              Export Format
            </DropdownMenuLabel>
            <DropdownMenuSeparator />
            <DropdownMenuItem
              data-testid="export-pdf-item"
              onClick={onExportPDF}
              className="rounded-none gap-2 cursor-pointer"
            >
              <FilePdf size={16} /> PDF
            </DropdownMenuItem>
            <DropdownMenuItem
              data-testid="export-xlsx-item"
              onClick={onExportXLSX}
              className="rounded-none gap-2 cursor-pointer"
            >
              <FileXls size={16} /> Excel (.xlsx)
            </DropdownMenuItem>
            <DropdownMenuItem
              data-testid="export-csv-item"
              onClick={onExportCSV}
              className="rounded-none gap-2 cursor-pointer"
            >
              <FileCsv size={16} /> CSV
            </DropdownMenuItem>
          </DropdownMenuContent>
        </DropdownMenu>
      </div>
    </header>
  );
}
